import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractCsvExportService } from '../utils/abstract-csv-export.service';
import { FileSaverService } from '../common/file/file-saver.service';
import { FileSaverUsecase } from '../../domain/model/file-saver-usecase.enum';
import { NetzbetreiberTeilgebieteInfo } from '../auth/netzbetreiber-teilgebiete-info';

@Injectable({
    providedIn: 'root',
})
export class PlanwertExportService extends AbstractCsvExportService {

    constructor() {
        super(inject(HttpClient), inject(FileSaverService));
    }

    public exportPlanwerteCSV(teilgebiet?: NetzbetreiberTeilgebieteInfo) {
        this.exportCsv(
            '/planwert/planwerte.csv',
            FileSaverUsecase.CSV_EXPORT_PLANWERTE,
            teilgebiet,
        );
    }
}
